import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormGenerateComponent} from './form-generate.component';
import {NzFormModule} from 'ng-zorro-antd/form';
import {ReactiveFormsModule} from '@angular/forms';
import {NzInputModule} from 'ng-zorro-antd/input';
import {NzCheckboxModule} from 'ng-zorro-antd/checkbox';
import {VssUiDirectivesModule} from '../directives/vss-ui-directives.module';
import {VssUiControlsModule} from '../controls/vss-ui-controls.module';
import {NzSelectModule} from 'ng-zorro-antd/select';
import {PipeModule} from '../pipe/pipe.module';



@NgModule({
  declarations: [FormGenerateComponent],
  exports: [FormGenerateComponent],
    imports: [
        CommonModule,
        NzFormModule,
        ReactiveFormsModule,
        NzInputModule,
        NzCheckboxModule,
        VssUiDirectivesModule,
        VssUiControlsModule,
        NzSelectModule,
        PipeModule
    ],
})
export class FormGenerateModule { }
